import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const assetTransAdapter = createEntityAdapter({})
const initialState = assetTransAdapter.getInitialState()

export const assetTransApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getassetTrans: builder.query({
            query: () => ({
                url: '/assettrans',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedassetTrans = responseData.map(assetTrans => {
                    // console.log(office)
                    assetTrans.id = assetTrans._id
                    // console.log(office)
                    return assetTrans
                });
                return assetTransAdapter.setAll(initialState, loadedassetTrans)
            },
            providesTags: (result, error, arg) => {
                console.log(result.ids) 
                if (result?.ids) {
                    return [
                        { type: 'AssetTrans', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'AssetTrans', id }))
                    ]
                } else return [{ type: 'AssetTrans', id: 'LIST' }]
            }
        }),
        addNewassetTrans: builder.mutation({
            query: initialUserData => ({
                url: '/assettrans',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'AssetTrans', id: "LIST" }
            ]
        }),
        updateassetTrans: builder.mutation({
            query: initialUserData => ({
                url: '/assettrans',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetTrans', id: arg.id }
            ]
        }), 
        deleteassetTrans: builder.mutation({
            query: ({ id }) => ({
                url: `/assettrans`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AssetTrans', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetassetTransQuery,
    useAddNewassetTransMutation,
    useUpdateassetTransMutation,
    useDeleteassetTransMutation
} = assetTransApiSlice

// returns the query result object
export const selectassetTransResult = assetTransApiSlice.endpoints.getassetTrans.select()

// creates memoized selector
const selectassetTransData = createSelector(
    selectassetTransResult,
    assetTransResult => assetTransResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllassetTrans,
    selectById: selectassetTransById,
    selectIds: selectassetTransIds
    // Pass in a selector that returns the users slice of state
} = assetTransAdapter.getSelectors(state => selectassetTransData(state) ?? initialState)